<template>
  <div class="col-md-12">
    <div class="ibox">
      <div class="ibox-content ibox-content-padding-xs">
        <h2 class="truncate">Xero Status</h2>

        <template v-if="!link">
          <br>
          <h3>
            Linked to Account
          </h3>

          <div class="row" v-if="data.tenant_type">
            <div class="col-md-4 strong">Tenant Type</div>
            <div class="col-md-8">{{data.tenant_type}}</div>
            <div class="col-md-4 strong">Tenant Id</div>
            <div class="col-md-8">{{data.tenant_id}}</div>
            <div class="col-md-4 strong">Tenant Name</div>
            <div class="col-md-8">{{data.tenant_name}}</div>
           </div>

          <hr>
          <h3>
            API Usage limits
          </h3>

          <div class="row" v-if="data.tenant_type">
            <div class="col-md-4 strong">Day Limit Remaining</div>
            <div class="col-md-8">{{data.day_limit_remaining}}</div>
            <div class="col-md-4 strong">Minute Limit Remaining</div>
            <div class="col-md-8">{{data.min_limit_remaining}}</div>
          </div>

        </template>

        <div v-if="link">
          <div class="alert alert-danger" role="alert" v-if="tokenRefreshFailed">
            <i class="alert-icon far fa-exclamation-triangle"></i>
            We have been unable to refresh your Xero Access Token and therefore your Xero link is currently <strong>disabled</strong>. In order to re-activate your link please "Disconnect" the connected Application here: <a href="https://identity.xero.com/account/apps/" target="blank">Connected Applications</a> then re-link Xero below.
          </div>

          <div class="alert alert-info" role="alert" v-if="displayRelink">
            <i class="alert-icon far fa-exclamation-triangle"></i>
            Your application is not currently linked to Xero, please hit the button below to link.
          </div>

          <a class="btn btn-primary" v-bind:href="link">Link Xero</a>
        </div>

      </div>

    </div><!-- /.ibox -->
  </div>
</template>


<script>
import { stateMapper } from 'mixins/settings'
import { mapState, mapActions } from 'vuex'

export default {
  mixins: [stateMapper],

  created () {
    this.getXeroStatus()
    this.getLink()
  },

  computed: {
    ...mapState('xero', ['data', 'link']),

    displayRelink () {
      return !this.data.refresh_token_failed
    },

    tokenRefreshFailed () {
      return this.data.refresh_token_failed
    }
  },

  methods: {
    ...mapActions('xero', ['getLink', 'getXeroStatus'])
  }
}
</script>



// WEBPACK FOOTER //
// Xero.vue?aedfb9e8